import React from 'react'
import Button from '../../../../common/button/Button'
import { handleLicensesConfirmationModal } from './Utils'
import useLicenseTable from '../context/LicenseTableContext'

const LicensesTableButton = ({ id, info, hasModal = null, btnName = '', btnClassName = '', btnDisabled = '', teamType = 'wooteams' }) => {

  const { setSelectedLicense, setSelectedModal } = useLicenseTable()

  return(
    <Button
      name={ btnName ? btnName : 'Open Modal' }
      className={ btnClassName ? btnClassName : 'msync-table-button' }
      onClick={ () => handleLicensesConfirmationModal( id, info, hasModal, setSelectedLicense, setSelectedModal, teamType ) }
      disabled={ btnDisabled ? btnDisabled : '' }
    />
  )
  
}

export default LicensesTableButton
